export default __webpack_public_path__ + "static/media/10.76058d77.jpg";